/*
 * @Author: Json Chen
 * @Date: 2021-07-22 11:31:21
 * @LastEditTime: 2022-06-13 17:34:14
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/LogisticMethods.tsx
 */

import EditDraggableTable from '@/src/components/DroppableTable/EditDraggableTable';
import {
  EditIcon,
  FrontTitle,
} from '@/src/components/EditableTable/EditableTable';
import { Form } from 'antd';
import React, { useMemo } from 'react';
import { SizeFittingTable } from 'src/components/Antd';
// import { useRequest } from 'ahooks';
// import CommonHeader from '@/src/components/CommonHeader';
// import Configuration from '@/src/components/Configuration/Configuration';
import { TableInput } from 'src/components/EditableTable/TableForm/TableForm';
// import { getCourierShow } from '@/src/pages/Settings/Logistics/CourierAccount/tools';
import styles from '../style.module.less';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const LogisticMethods = ({
  value: logisticsMethods,
  onChange,
  isPrimary,
  disableEdit,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const list = useMemo(() => {
    const sortList = (logisticsMethods || []).map((item) => {
      if (disableEdit) {
        return {
          ...item,
          dragable: false,
          hideDragHandler: true,
          disabled: true,
        };
      }

      const checked = item.checked;
      const disabled = !item.enabled;

      return {
        ...item,
        dragable: checked,
        checked: checked,
        hideDragHandler: !checked,
        disabled: disabled,
      };
    });

    // 已勾选,可选择
    const checkedList = sortList.filter((i) => i.checked && !i.disabled);
    // 未勾选, 可选择
    const unCheckedList = sortList.filter((i) => !i.checked && !i.disabled);

    // 已勾选, 不可选择
    const disabledCheckedList = sortList.filter((i) => i.checked && i.disabled);

    // 未勾选, 不可选择
    const disabledList = sortList.filter((i) => !i.checked && i.disabled);

    return [
      ...(checkedList || []),
      ...(unCheckedList || []),
      ...(disabledCheckedList || []),
      ...(disabledList || []),
    ]; //checkedList.concat(unCheckedList, disabledCheckedList, disabledList);
  }, [logisticsMethods]);
  const columns = [
    {
      title: getI18n('general.logisticMethod'),
      dataIndex: 'logisticsMethod',
      key: 'logisticsMethod',
      default: true,
      minWidth: 192,
    },
    {
      title: (
        <FrontTitle>
          <EditIcon />
          <span>
            {getI18n('salesChannelLogistics.index.logisticMethodTitle')}
          </span>
        </FrontTitle>
      ),
      key: 'title',
      dataIndex: 'title',
      default: true,
      render: (text, record, index) => {
        return (
          <Form.Item
            shouldUpdate={(p, c) => {
              const pv = get(p, 'logisticsMethods');
              const cv = get(c, 'logisticsMethods');
              return pv !== cv;
            }}>
            {({ getFieldValue }) => {
              const iniV = getFieldValue('logisticsMethods') || [];
              const logisticsMethod = get(record, 'logisticsMethod');
              const actualIndex = iniV.findIndex(
                (i) => i.logisticsMethod === logisticsMethod,
              );
              const _index = actualIndex !== -1 ? actualIndex : index;
              return (
                <Form.Item name={['logisticsMethods', _index, 'title']}>
                  <TableInput disabled={disableEdit} />
                </Form.Item>
              );
            }}
          </Form.Item>
        );
      },
      width: 320,
    },
    {
      title: (
        <FrontTitle>
          <EditIcon />
          <span>
            {getI18n('salesChannelLogistics.index.logisticMethodRemarks')}
          </span>
        </FrontTitle>
      ),
      dataIndex: 'remarks',
      key: 'remarks',
      default: true,
      width: 512,
      render: (text, record, index) => {
        return (
          <Form.Item
            shouldUpdate={(p, c) => {
              const pv = get(p, 'logisticsMethods');
              const cv = get(c, 'logisticsMethods');
              return pv !== cv;
            }}>
            {({ getFieldValue }) => {
              const iniV = getFieldValue('logisticsMethods') || [];
              const logisticsMethod = get(record, 'logisticsMethod');
              const actualIndex = iniV.findIndex(
                (i) => i.logisticsMethod === logisticsMethod,
              );
              const _index = actualIndex !== -1 ? actualIndex : index;
              return (
                <Form.Item name={['logisticsMethods', _index, 'remarks']}>
                  <TableInput disabled={disableEdit} />
                </Form.Item>
              );
            }}
          </Form.Item>
        );
      },
    },
  ];

  const onSelectChange = (selectedList) => {
    onChange(
      list.map((item) => {
        return {
          ...item,
          logisticsMethod: item.logisticsMethod,
          checked: selectedList.includes(item.logisticsMethod),
          enabled: !item.disabled,
        };
      }),
    );
  };
  const rowSelection = {
    selectedRowKeys: (logisticsMethods || [])
      .filter((l) => l.checked)
      .map((l) => l.logisticsMethod),
    getCheckboxProps: (record) => ({
      disabled: !isPrimary || record.disabled,
    }),
    onChange: onSelectChange,
  };

  const onTableChange = (newList) => {
    //console.log(newList);
    onChange(
      newList,
      // newList.map((i) => ({
      //   checked: i.checked,
      //   logisticsMethod: i.logisticsMethod,
      //   enabled: !i.disabled,
      // })),
    );
  };
  const TableProps = {
    id: 'LogisticMethods',
    rowKey: 'logisticsMethod',
    dataSource: list,
    columns: columns,
    rowSelection: rowSelection,
    onTableChange: onTableChange,
    pagination: false,
    hideAllDragHandlers: disableEdit,
  };

  return (
    <div className={styles.logisticMethodTable}>
      {isPrimary ? (
        <EditDraggableTable {...TableProps} />
      ) : (
        <SizeFittingTable {...TableProps} />
      )}
    </div>
  );
};

export default LogisticMethods;
